module.exports = __webpack_public_path__ + "img/map.711a1355.svg";